import { LoginStatus } from "../constants/Constants";
import { Paths } from "../constants/UrlConstants";

export function redirectForInvalidPolicyValidationStatus(status, history) {
  if (status === LoginStatus.PolicyLocked) {
    history.push(Paths.PolicyLocked);
  } else if (status === LoginStatus.InvalidPolicyStatus) {
    history.push(Paths.OnlineAccessUnavailable);
  } else if (status === LoginStatus.RestrictedPolicy) {
    history.push(Paths.RestrictedPolicy);
  } else if (status === LoginStatus.RestrictedGroup) {
    history.push(Paths.RestrictedGroup);
  } else if (status === LoginStatus.Restricted) {
    history.push(Paths.RestrictedUser);
  } else if (status === LoginStatus.MovedToAxaHealth) {
    history.push(Paths.MovedToAxaHealth);
  } else {
    history.push(Paths.Error);
  }
}
